import { BackgroundMedia } from '../page-components/background-media.model';
import { Border } from '../page-components/border.model';
import { Css } from '../page-components/css.model';
import { Margin } from '../page-components/margin.model';
import { Padding } from '../page-components/padding.model';
import { HeaderLinks } from './header.model';

export class Footer {
  MaxWidth: string = '100%';
  Color: string = '';
  Padding?: Padding;
  Margin?: Margin;
  Border?: Border;
  Background?: BackgroundMedia;
  Columns?: FooterColumn[] | null;
  Css?: Css;
  ShowCopyright: boolean = false;
  CopyrightText: string = '';
  CopyrightColor: string = '';
  CopyrightBackgroundColor: string = '';
  TemplateColumns?: string;
  ColumnGap?: string;
}

export class FooterColumn {
  Heading?: string | null;
  ContentAboveLinks?: string | null;
  Links?: HeaderLinks[] | null;
  ContentBelowLinks?: string | null;
}
